import {
  MyChartOpenSchedulingConfig,
  ProviderMatchProviderV9
} from '@kyruus/types';
import React from 'react';
import { buildMyChartLoginUrl } from './utilities';
import LinkIcon from '@kyruus/react-ikons/Link';
import { FullWidthButtonLink, FullWidthButtonLinkWithIcon } from './styles';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import messages from '../../lib/messages';
import {
  TrackingFunction,
  trackMyChartLoginClicked,
  trackViewAvailabilityClicked
} from '../../lib/tracking-utils';
import { PROFILE_SECTION_IDS } from '../../lib/constants';

export interface OpenSchedulingScheduleAppointmentProps {
  config: Required<MyChartOpenSchedulingConfig>;
  provider: ProviderMatchProviderV9;
  track: TrackingFunction;
}

function OpenSchedulingScheduleAppointment(
  props: OpenSchedulingScheduleAppointmentProps & WrappedComponentProps
) {
  const loginUrl = buildMyChartLoginUrl(props.config);

  return (
    <>
      <section aria-labelledby="NewPatientHeader">
        <h4 id="NewPatientHeader">New Patients</h4>
        <FullWidthButtonLink
          href={`#${PROFILE_SECTION_IDS.APPOINTMENTS}`}
          mode="primary"
          onClick={() =>
            trackViewAvailabilityClicked(props.track, props.provider.id)
          }
        >
          {props.intl.formatMessage(messages.viewAvailabilityButtonText)}
        </FullWidthButtonLink>
      </section>
      <section aria-labelledby="ExistingPatientHeader">
        <h4 id="ExistingPatientHeader">Existing Patients</h4>
        <FullWidthButtonLinkWithIcon
          mode="ghost"
          icon={<LinkIcon />}
          active={true}
          target="_blank"
          rel="noopener"
          href={loginUrl}
          onClick={() => trackMyChartLoginClicked(props.track)}
        >
          {props.intl.formatMessage(messages.myChartLoginButtonText)}
        </FullWidthButtonLinkWithIcon>
      </section>
    </>
  );
}

export default withErrorBoundary(injectIntl(OpenSchedulingScheduleAppointment));
